import { Shippings, FieldsTypes, fieldsConfig } from '@pages/checkout-app/types';
const DEFAULT_APPEARANCE_LIMIT = 10000;
const DEFAULT_PERCENT_TEST_VARIANT_TRAFFIC = 50;
const DEFAULT_MAX_NUMBER_TO_SAVE = 1000000000;
export class ABTestDTO {
  shipping: Shippings;
  variant: any;
  constructor(shipping?: Shippings, variant?: any) {
    this.shipping = shipping;
    this.variant = variant;
  }

  public createVariantDTO() {
    const variantDTO: any = {};

    variantDTO.name = this.shipping.name;
    variantDTO.notes = this.shipping.notes;
    variantDTO.displayEstDelivery = this.shipping.displayEstDelivery;
    variantDTO.displayEstimatedDeliveryBusinessDays = this.shipping.displayEstimatedDeliveryBusinessDays;
    variantDTO.deliveryPromiseMax = this.shipping.shippingMethod?.maxDays ?? this.shipping.shippingMethod?.maxHours;
    variantDTO.deliveryPromiseMin = this.shipping.shippingMethod?.minDays ?? this.shipping.shippingMethod?.minHours;
    variantDTO.calculatePackageDimension = this.shipping.calculatePackageDimension;
    variantDTO.deliveryPromiseArrivalSingleDateDisplayText = this.shipping.deliveryPromiseArrivalSingleDateDisplayText;
    variantDTO.deliveryPromiseArrivalDateRangeDisplayText = this.shipping.deliveryPromiseArrivalDateRangeDisplayText;

    if (this.shipping.rate) {
      variantDTO.rate = this.shipping.rate;
    }
    if (this.shipping.minOrderPriceRange) {
      variantDTO.minOrderPriceRange = this.shipping.minOrderPriceRange;
    }
    if (this.shipping.maxOrderPriceRange) {
      variantDTO.maxOrderPriceRange = this.shipping.maxOrderPriceRange;
    }
    if (this.shipping.additionalPriceRanges != undefined) {
      variantDTO.additionalPriceRanges = this.shipping.additionalPriceRanges;
    }
    if (this.shipping.rateConversion) {
      variantDTO.rateConversion = this.shipping.rateConversion;
    }
    if (this.shipping.percentageOfCarrierCost) {
      variantDTO.percentageOfCarrierCost = this.shipping.percentageOfCarrierCost;
    }
    if (this.shipping.flatAmount) {
      variantDTO.flatAmount = this.shipping.flatAmount;
    }
    if (this.variant.percentTestVariantTraffic) {
      variantDTO.percentTestVariantTraffic = this.variant.percentTestVariantTraffic;
    } else {
      variantDTO.percentTestVariantTraffic = DEFAULT_PERCENT_TEST_VARIANT_TRAFFIC;
    }
    if (this.variant.appearanceLimit) {
      variantDTO.appearanceLimit = this.variant.appearanceLimit;
    } else {
      variantDTO.appearanceLimit = null;
    }
    if (this.variant.hideVariantB != undefined) {
      variantDTO.hideVariantB = this.variant.hideVariantB;
    }
    if (this.variant.disableRatesOptimization != undefined) {
      variantDTO.disableRatesOptimization = this.variant.disableRatesOptimization;
    }
    if (this.variant.abtestGroupId) {
      variantDTO.abtestGroupId = this.variant.abtestGroupId;
    }

    return variantDTO;
  }

  public normalizeDTOValues(values, config: fieldsConfig[]) {
    config.forEach((field) => {
      if (field.type === FieldsTypes.NUMBER) {
        if (+values[field.fieldName] > DEFAULT_MAX_NUMBER_TO_SAVE) {
          throw new Error(`number can be maximum of ${DEFAULT_MAX_NUMBER_TO_SAVE}`);
        }
        values[field.fieldName] = +values[field.fieldName];
      }
    });
  }
}
